/**
 * paymentErrors.js — Détection et formatage des erreurs de paiement.
 *
 * Centralise les invariants métier communs à tous les flows de paiement
 * (stripeModal, paypalModal, nowPaymentsModal, CartCheckoutModal).
 *
 * §5/§9 — Un seul endroit pour cette logique, importée partout.
 */

/**
 * Renvoie true si l'erreur indique qu'une ressource est verrouillée (lock 409).
 * Invariant backend : le serveur retourne HTTP 409 ou un message contenant
 * "already being purchased" ou "locked" quand tileLockService est actif (§13).
 *
 * @param {Error|string|null} error
 * @returns {boolean}
 */
export function isPaymentLocked(error) {
  const msg = (error && error.message) ? error.message : String(error || '');
  return (
    msg.includes('already being purchased') ||
    msg.includes('409') ||
    msg.includes('locked')
  );
}

/**
 * Extrait le message d'erreur lisible depuis un objet Error / réponse Axios.
 *
 * @param {Error|null} error
 * @param {string} fallback
 * @returns {string}
 */
export function getPaymentErrorMessage(error, fallback = 'Unable to initialise payment. Please try again.') {
  if (!error) return fallback;
  return error?.response?.data?.message || error?.message || fallback;
}
